import React, { useState } from 'react'
import Preloader from '../components/Preloader'
import Footer from '../components/Footer';
import ScrollReveal from '../components/ScrollReveal';
import Header from '../components/Header';
import { FaSearchPlus, FaTimes } from 'react-icons/fa';

const galleryImages = [
    { id: 1, src: '/assets/land5.jpeg', alt: 'gallery image', category: 'Our Gallery' },
    { id: 2, src: '/assets/happymoney.jpg', alt: 'gallery image', category: 'Our Gallery' },
    { id: 2, src: '/assets/land3.jpeg', alt: 'gallery image', category: 'Our Gallery' },
];

const Gallery = () => {
    const [selectedCategory, setSelectedCategory] = useState('All');
    const [selectedImage, setSelectedImage] = useState(null);
    const categories = ['All', ...new Set(galleryImages.map(img => img.category))];

    const filteredImages = selectedCategory === 'All' 
        ? galleryImages 
        : galleryImages.filter(img => img.category === selectedCategory);

    return (
        <div className='font-nixie-one bg-white min-h-screen text-gray-800'>
            <Header />
            <Preloader />
            <main>
                {/* Hero Section */}
                <section className="relative h-[40vh] md:h-[50vh] bg-cover bg-center" style={{ backgroundImage: "url('/assets/oldlady1.jpg')" }}>
                    <div className="absolute inset-0 bg-blue-900/60 flex items-center justify-center">
                        <ScrollReveal animationClass="animate-fade-up" threshold={0.1} delay={200}>
                        <div className="text-center text-white px-4">
                            <h1 className="text-2xl md:text-3xl font-bold mb-4 capitalize tracking-wide">Our Gallery</h1>
                            <p className="text-sm md:text-sm max-w-2xl mx-auto font-light">
                                Explore moments from our journey, community engagements, and the impact we're making across Ghana.
                            </p>
                        </div>
                        </ScrollReveal>
                    </div>
                </section>
                
                {/* Gallery Content */}
                <section className="py-16 px-4 container mx-auto">
                    {/* Filter Buttons */}
                    <ScrollReveal animationClass="animate-fade-up" threshold={0.1}>
                        <div className="flex flex-wrap justify-center gap-4 mb-12">
                            {categories.map((category, index) => (
                                <button
                                    key={index}
                                    onClick={() => setSelectedCategory(category)}
                                    className={`px-6 py-2 rounded-full text-sm font-semibold transition-all duration-300 ${
                                        selectedCategory === category
                                            ? 'bg-blue-600 text-white shadow-md'
                                            : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                                    }`}
                                >
                                    {category}
                                </button>
                            ))}
                        </div>
                    </ScrollReveal>

                    {/* Image Grid */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
                        {filteredImages.map((image) => (
                            <ScrollReveal key={image.id} animationClass="animate-fade-in" threshold={0.1}>
                                <div 
                                    className="group relative overflow-hidden rounded-xl shadow-lg cursor-pointer h-64 md:h-72"
                                    onClick={() => setSelectedImage(image)}
                                >
                                    <img 
                                        src={image.src} 
                                        alt={image.alt} 
                                        className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                                        loading='lazy'
                                    />
                                    <div className="absolute inset-0 bg-blue-900/0 group-hover:bg-blue-900/70 transition-colors duration-300 flex flex-col items-center justify-center opacity-0 group-hover:opacity-100">
                                        <FaSearchPlus className="text-white text-3xl mb-2 transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300" />
                                        <p className="text-white font-semibold text-lg transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300 delay-75">{image.alt}</p>
                                        <p className="text-blue-200 text-sm transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300 delay-100">{image.category}</p>
                                    </div>
                                </div>
                            </ScrollReveal>
                        ))}
                    </div>
                </section>

                {/* Lightbox Modal */}
                {selectedImage && (
                    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/95 p-4 backdrop-blur-sm animate-fade-in" onClick={() => setSelectedImage(null)}>
                        <button 
                            className="absolute top-5 right-5 text-white/80 hover:text-white text-4xl transition-colors focus:outline-none z-50"
                            onClick={() => setSelectedImage(null)}
                        >
                            <FaTimes />
                        </button>
                        <div className="relative max-w-5xl w-full max-h-full flex flex-col items-center justify-center" onClick={(e) => e.stopPropagation()}>
                            <img 
                                src={selectedImage.src} 
                                alt={selectedImage.alt} 
                                className="max-w-full max-h-[80vh] object-contain rounded-md shadow-2xl"
                                loading='lazy'
                            />
                            <div className="mt-4 text-center">
                                <h3 className="text-white text-2xl font-bold mb-1">{selectedImage.alt}</h3>
                                <p className="text-blue-400 text-sm font-semibold uppercase tracking-wider">{selectedImage.category}</p>
                            </div>
                        </div>
                    </div>
                )}
            </main>
            <Footer />
        </div>
    )
}

export default Gallery
